import { memo } from 'react';

function SpreadV2Label() {
  return <span>Apparent size</span>;
}

export default memo(SpreadV2Label);
